// combatpro/views/MonsterStudioView.js
//
// view-monster-studio. Stage 33 left this as an empty preserved container shell
// (the Monster Studio inner content was deferred). Stage 54 (Monster Studio
// Foundation) mounts the structural shell: the view container keeps its id and
// class verbatim and now renders MonsterStudioWorkspace, which composes the hero,
// library sidebar, tab nav, editor-panel mount, and command bar. This mirrors
// EncounterView -> EncounterSummary and MonsterPanel -> MonsterWorkspace (a view
// that composes its body from sub-components).
//
// Presentational shell only - no CRUD, cloud, version, collection, preview,
// import/export, template, test, search, filter, save, or delete behaviour is
// wired in this stage. No CombatContext use here, no new context ownership, no
// runtime logic. The Spell Studio is untouched.

import React from 'react';
import MonsterStudioWorkspace from '../panels/monsters/studio/MonsterStudioWorkspace';

function MonsterStudioView() {
  return (
    <div className="vi-view" id="view-monster-studio">
      <MonsterStudioWorkspace />
    </div>
  );
}

export default MonsterStudioView;
